import type { CompTopicFatiguePoint } from "@nexus/contracts";
import type { CompTopicDetailFatigueKpi } from "./compTopicDetailKpis.js";

export function compFatigueValueForKpi(
  point: CompTopicFatiguePoint,
  kpi: CompTopicDetailFatigueKpi,
): number {
  if (kpi === "Days") return point.days;
  if (kpi === "Assets") return point.assets;
  if (kpi === "Days/Assets") return point.daysPerAsset ?? 0;
  return point.assetPct ?? 0;
}

export function compFatigueKpiDisplayFormat(
  kpi: CompTopicDetailFatigueKpi,
): "count" | "percent" {
  return kpi === "Asset %" ? "percent" : "count";
}
